import { render, staticRenderFns } from "./Queens.vue?vue&type=template&id=688912d5&scoped=true"
import script from "./Queens.vue?vue&type=script&lang=js"
export * from "./Queens.vue?vue&type=script&lang=js"
import style0 from "./Queens.vue?vue&type=style&index=0&id=688912d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688912d5",
  null
  
)

export default component.exports